"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FontLoader = void 0;
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@emotion/react");
var _useIsomorphicLayoutEffect = require("../../hooks/useIsomorphicLayoutEffect");
var _isSSR = require("../../utils/isSSR");
var _FontCSS = require("../FontCSS");
var _utils = require("./utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const FontLoader = _ref => {
  let {
    emberUrl
  } = _ref;
  const [fontCSS, setFontsCSS] = (0, _react.useState)(() => {
    if ((0, _isSSR.isSSR)() || process.env.NODE_ENV === 'test') return (0, _FontCSS.getFontCSS)(emberUrl);else return '';
  });
  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(() => {
    if (!(0, _isSSR.isSSR)() && process.env.NODE_ENV !== 'test') (0, _utils.getUnloadedFonts)(emberUrl).then(setFontsCSS);
  }, [emberUrl]);
  return (0, _react2.jsx)(_react2.Global, {
    styles: fontCSS
  });
};
exports.FontLoader = FontLoader;